var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"value":_vm.isShow,"max-width":550,"persistent":""}},[(_vm.announcementDisplay)?_c('MyAnnouncementCard',{attrs:{"announcement":_vm.announcementDisplay},on:{"markRead":_vm.onMarkRead,"remindLater":_vm.nextTime,"clearCache":_vm.onClearCache,"appUpdate":_vm.onAppUpdate}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }